
/* eslint-disable no-param-reassign */

import BalanceApi from '@/services/balance';

const state = {
  nextPayment: {
    value: null,
    date: null,
  },
  scheduledPayment: {
    value: null,
    date: null,
  },
  openBalance: null,
  actualBalance: null,
};

const getters = {
  nextPaymentValue: currentState => currentState.nextPayment.value,
  nextPaymentDate: currentState => currentState.nextPayment.date,
  scheduledPaymentValue: currentState => currentState.scheduledPayment.value,
  scheduledPaymentDate: currentState => currentState.scheduledPayment.date,
  openBalance: currentState => currentState.openBalance,
  actualBalance: currentState => currentState.actualBalance,
};

const actions = {
  async fetchBalanceInfo({ commit }) {
    const balance = await BalanceApi.getBalance();
    commit('setBalanceInfo', balance);
  },
};

const mutations = {
  setBalanceInfo(currentState, balance) {
    currentState.nextPayment.value = balance.nextPayment.value;
    currentState.nextPayment.date = balance.nextPayment.date;
    currentState.scheduledPayment.value = balance.scheduledPayment.value;
    currentState.scheduledPayment.date = balance.scheduledPayment.date;
    currentState.openBalance = balance.openBalance;
    currentState.actualBalance = balance.actualBalance;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
